module.exports = __webpack_public_path__ + "static/media/preferenceSelected.1297cb81.svg";